import FileDownload from './FileDownload';

export default FileDownload;
